<!--
 * @Author: Niklaus
 * @Date: 2026-04-14 10:16:25
 * @LastEditTime: 2026-05-08 17:39:16
 * @LastEditors: Niklaus
 * @Description: 补充协议列表
-->
<template>
    <basic-container>
        <avue-crud ref="table" :data="tableData" :page.sync="page" :option="tableOption" :table-loading="tableLoading"
            @search-change="searchChange" @on-load="onLoad" @refresh-change="onLoad">
            <template slot-scope="{ size, row }" slot="menu">
                <el-button icon="el-icon-view" :size="size || 'small'" type="text"
                    @click="handleDetail(row)">查看</el-button>
                <el-button v-if="row.approval_status && [3, 4].includes(row.approval_status)" icon="el-icon-view"
                    :size="size || 'small'" type="text" @click="showTaskInstance(row)">审批记录</el-button>
            </template>
        </avue-crud>

        <!-- 查看详情 -->
        <el-dialog :visible.sync="showDetail" :close-on-click-modal="false" :destroy-on-close="true"
            :with-header="false" :top="'8vh'" :body-style="{ padding: '0px' }" width="70%" @close="showDetail = false">
            <div slot="title" class="header-title">
                <!-- <span class="fts-16">{{ title }}</span> -->
            </div>
            <component v-if="component" :is="component" :id="contractInfo.id" :supplementaryType="typeArray"
                :contractInfo="contractInfo" mode="view">
            </component>
        </el-dialog>

        <!-- 查看审批记录 -->
        <el-drawer :visible.sync="todoDrawer" :size="400" :withHeader="false" append-to-body>
            <el-container v-if="todoDrawer" class="h-100p">
                <el-header class="bor-b" height="50px">
                    <el-page-header class="lh-50" @back="todoDrawer = false" content="审批记录"></el-page-header>
                </el-header>
                <el-main class="pad-15">
                    <TodoTask :id="instanceId"></TodoTask>
                </el-main>
            </el-container>
        </el-drawer>
    </basic-container>
</template>
<script>
import { getMetaCommonList } from "@/api/busiMode/metaCommon";

import ZqfylqForm from "./supplementarys/zqfylqForm.vue"
import ContractReletForm from "./supplementarys/contractReletForm.vue"
import TerminationForm from "./supplementarys/terminationForm.vue"
import TripartiteAgreementForm from "./supplementarys/tripartiteAgreementForm.vue"
import TodoTask from "@/views/flow/todo-task.vue";

import * as dictService from "@/api/system/dictbiz";

export default {
    components: {
        ZqfylqForm,
        ContractReletForm,
        TerminationForm,
        TripartiteAgreementForm,
        TodoTask
    },
    provide() {
        return {
            supplementarysIndex: this,
        }
    },

    data() {
        return {
            model: 'wisdom_park.wp_contract_supplementary',
            tableLoading: false,
            downLoading: false,
            tableData: [],
            page: {
                pageSizes: this.$store.state.common.pageSizes,
                pagerCount: this.$store.state.common.pagerCount,
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            tableOption: {
                height: 'auto',
                searchMenuSpan: 6,
                border: true,
                delBtn: false,
                editBtn: false,
                addBtn: false,
                viewBtn: false,
                referchBtn: false,
                searchLabelWidth: 120,
                menuWidth: 150,
                index: true,
                column: [
                    {
                        label: "补充协议编号",
                        prop: "supplementary_code",
                        search: true,
                        searchSpan: 6,
                    },
                    {
                        label: "主合同编号",
                        prop: "contract_code",
                        search: true,
                        searchSpan: 6,
                        labelWidth: 150,
                    },
                    {
                        label: "协议类型",
                        prop: "supplementary_type",
                        width: 150,
                        search: true,
                        type: "select",
                        dicUrl: dictService.getUrl("SupplementaryType"),
                        props: {
                            label: "dictValue",
                            value: "dictKey",
                        },
                        dataType: "number",
                    },
                    {
                        label: "租赁企业",
                        prop: "lessee_a_name",
                        width: 250
                    },
                    {
                        label: "审批状态",
                        prop: "approval_status",
                        width: 150,
                        dicUrl: dictService.getUrl("ApprovalStatus"),
                        props: {
                            label: "dictValue",
                            value: "dictKey",
                        },
                        dataType: 'string',
                    },
                    {
                        label: "合同状态",
                        prop: "status",
                        width: 150,
                        dicUrl: dictService.getUrl("ContractStatus"),
                        props: {
                            label: "dictValue",
                            value: "dictKey",
                        },
                        dataType: 'string',

                    },
                ]
            },
            orders: [
                { field: 'create_time', sort: 'DESC' }
            ],
            params: {},
            showDetail: false,
            contractInfo: {},
            component: null,
            comps: ['TripartiteAgreementForm', 'TerminationForm', 'ContractReletForm', 'ZqfylqForm'],
            todoDrawer: false,
            instanceId: '',
            typeArray: []
        }
    },

    created() {
        this.getDict()
    },
    methods: {
        searchChange(params, done) {
            this.params = params;
            this.page.currentPage = 1;
            done();
            this.onLoad()
        },
        onLoad() {
            this.tableLoading = true;
            this.tableData = [];
            let wheres = []
            Object.keys(this.params).forEach(key => {
                wheres.push({ field: key, value: this.params[key], op: 'LIKE' })
            })

            getMetaCommonList(this.model, {
                current: this.page.currentPage,
                size: this.page.pageSize,
                wheres: wheres,
                orders: this.orders
            }).then(
                res => {
                    this.tableLoading = false;
                    this.tableData = res.data.data.records;
                    this.page.total = res.data.data.total;
                }
            ).catch(e => {
                this.tableLoading = false;
            })
        },

        /**
         * @Author: Niklaus
         * @Description: 根据不同的协议类型打开不同的组件
         * @param {*} row
         */
        handleDetail(row) {
            this.contractInfo = row
            this.component = this.comps[row.supplementary_type - 1]
            this.showDetail = true
        },

        /**显示审批记录 */
        showTaskInstance(obj) {
            this.instanceId = obj.process_instance_id;
            this.todoDrawer = true;
        },

        getDict() {
            dictService.getDictionary({ code: 'SupplementaryType' }).then(res => {
                console.log(res.data.data)
                this.typeArray = res.data.data
            })
        }
    }
}
</script>